import { CustomerPaymentStatusPipe } from './customer-payment.status.pipe';

export function CustomerPaymentStatusFilter ( customerPaymentStatusPipe : CustomerPaymentStatusPipe ) {
  return ( value : string ) : string => customerPaymentStatusPipe.transform(value);
}
